/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var extproto_ext_pb = require('../../../../../../../extproto/ext_pb.js');
goog.exportSymbol('proto.common.portal.gloo.solo.io.DataSource', null, global);
goog.exportSymbol('proto.common.portal.gloo.solo.io.DataSource.ConfigMapData', null, global);
goog.exportSymbol('proto.common.portal.gloo.solo.io.LabelExpression', null, global);
goog.exportSymbol('proto.common.portal.gloo.solo.io.LabelExpression.Operator', null, global);
goog.exportSymbol('proto.common.portal.gloo.solo.io.ObjectRef', null, global);
goog.exportSymbol('proto.common.portal.gloo.solo.io.SecretRef', null, global);
goog.exportSymbol('proto.common.portal.gloo.solo.io.Selector', null, global);
goog.exportSymbol('proto.common.portal.gloo.solo.io.State', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.portal.gloo.solo.io.Selector = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.portal.gloo.solo.io.Selector.repeatedFields_, null);
};
goog.inherits(proto.common.portal.gloo.solo.io.Selector, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.common.portal.gloo.solo.io.Selector.displayName = 'proto.common.portal.gloo.solo.io.Selector';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.portal.gloo.solo.io.Selector.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.portal.gloo.solo.io.Selector.prototype.toObject = function(opt_includeInstance) {
  return proto.common.portal.gloo.solo.io.Selector.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.portal.gloo.solo.io.Selector} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.portal.gloo.solo.io.Selector.toObject = function(includeInstance, msg) {
  var f, obj = {
    matchLabelsMap: (f = msg.getMatchLabelsMap()) ? f.toObject(includeInstance, undefined) : [],
    namespacesList: jspb.Message.getRepeatedField(msg, 2)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.portal.gloo.solo.io.Selector}
 */
proto.common.portal.gloo.solo.io.Selector.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.portal.gloo.solo.io.Selector;
  return proto.common.portal.gloo.solo.io.Selector.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.portal.gloo.solo.io.Selector} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.portal.gloo.solo.io.Selector}
 */
proto.common.portal.gloo.solo.io.Selector.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getMatchLabelsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addNamespaces(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.portal.gloo.solo.io.Selector.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.portal.gloo.solo.io.Selector.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.portal.gloo.solo.io.Selector} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.portal.gloo.solo.io.Selector.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchLabelsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getNamespacesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * map<string, string> match_labels = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.common.portal.gloo.solo.io.Selector.prototype.getMatchLabelsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


proto.common.portal.gloo.solo.io.Selector.prototype.clearMatchLabelsMap = function() {
  this.getMatchLabelsMap().clear();
};


/**
 * repeated string namespaces = 2;
 * @return {!Array<string>}
 */
proto.common.portal.gloo.solo.io.Selector.prototype.getNamespacesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.common.portal.gloo.solo.io.Selector.prototype.setNamespacesList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.common.portal.gloo.solo.io.Selector.prototype.addNamespaces = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


proto.common.portal.gloo.solo.io.Selector.prototype.clearNamespacesList = function() {
  this.setNamespacesList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.portal.gloo.solo.io.DataSource = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.common.portal.gloo.solo.io.DataSource.oneofGroups_);
};
goog.inherits(proto.common.portal.gloo.solo.io.DataSource, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.common.portal.gloo.solo.io.DataSource.displayName = 'proto.common.portal.gloo.solo.io.DataSource';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.common.portal.gloo.solo.io.DataSource.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.common.portal.gloo.solo.io.DataSource.SourceTypeCase = {
  SOURCE_TYPE_NOT_SET: 0,
  INLINE_STRING: 1,
  INLINE_BYTES: 2,
  FETCH_URL: 3,
  CONFIG_MAP: 4
};

/**
 * @return {proto.common.portal.gloo.solo.io.DataSource.SourceTypeCase}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.getSourceTypeCase = function() {
  return /** @type {proto.common.portal.gloo.solo.io.DataSource.SourceTypeCase} */(jspb.Message.computeOneofCase(this, proto.common.portal.gloo.solo.io.DataSource.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.toObject = function(opt_includeInstance) {
  return proto.common.portal.gloo.solo.io.DataSource.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.portal.gloo.solo.io.DataSource} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.portal.gloo.solo.io.DataSource.toObject = function(includeInstance, msg) {
  var f, obj = {
    inlineString: jspb.Message.getFieldWithDefault(msg, 1, ""),
    inlineBytes: msg.getInlineBytes_asB64(),
    fetchUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    configMap: (f = msg.getConfigMap()) && proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.portal.gloo.solo.io.DataSource}
 */
proto.common.portal.gloo.solo.io.DataSource.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.portal.gloo.solo.io.DataSource;
  return proto.common.portal.gloo.solo.io.DataSource.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.portal.gloo.solo.io.DataSource} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.portal.gloo.solo.io.DataSource}
 */
proto.common.portal.gloo.solo.io.DataSource.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInlineString(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setInlineBytes(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFetchUrl(value);
      break;
    case 4:
      var value = new proto.common.portal.gloo.solo.io.DataSource.ConfigMapData;
      reader.readMessage(value,proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.deserializeBinaryFromReader);
      msg.setConfigMap(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.portal.gloo.solo.io.DataSource.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.portal.gloo.solo.io.DataSource} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.portal.gloo.solo.io.DataSource.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getConfigMap();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.serializeBinaryToWriter
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.portal.gloo.solo.io.DataSource.ConfigMapData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.displayName = 'proto.common.portal.gloo.solo.io.DataSource.ConfigMapData';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.prototype.toObject = function(opt_includeInstance) {
  return proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.portal.gloo.solo.io.DataSource.ConfigMapData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    namespace: jspb.Message.getFieldWithDefault(msg, 2, ""),
    key: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.portal.gloo.solo.io.DataSource.ConfigMapData}
 */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.portal.gloo.solo.io.DataSource.ConfigMapData;
  return proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.portal.gloo.solo.io.DataSource.ConfigMapData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.portal.gloo.solo.io.DataSource.ConfigMapData}
 */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.portal.gloo.solo.io.DataSource.ConfigMapData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string namespace = 2;
 * @return {string}
 */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.prototype.setNamespace = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string key = 3;
 * @return {string}
 */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.common.portal.gloo.solo.io.DataSource.ConfigMapData.prototype.setKey = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string inline_string = 1;
 * @return {string}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.getInlineString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.common.portal.gloo.solo.io.DataSource.prototype.setInlineString = function(value) {
  jspb.Message.setOneofField(this, 1, proto.common.portal.gloo.solo.io.DataSource.oneofGroups_[0], value);
};


proto.common.portal.gloo.solo.io.DataSource.prototype.clearInlineString = function() {
  jspb.Message.setOneofField(this, 1, proto.common.portal.gloo.solo.io.DataSource.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.hasInlineString = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes inline_bytes = 2;
 * @return {!(string|Uint8Array)}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.getInlineBytes = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes inline_bytes = 2;
 * This is a type-conversion wrapper around `getInlineBytes()`
 * @return {string}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.getInlineBytes_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getInlineBytes()));
};


/**
 * optional bytes inline_bytes = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getInlineBytes()`
 * @return {!Uint8Array}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.getInlineBytes_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getInlineBytes()));
};


/** @param {!(string|Uint8Array)} value */
proto.common.portal.gloo.solo.io.DataSource.prototype.setInlineBytes = function(value) {
  jspb.Message.setOneofField(this, 2, proto.common.portal.gloo.solo.io.DataSource.oneofGroups_[0], value);
};


proto.common.portal.gloo.solo.io.DataSource.prototype.clearInlineBytes = function() {
  jspb.Message.setOneofField(this, 2, proto.common.portal.gloo.solo.io.DataSource.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.hasInlineBytes = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string fetch_url = 3;
 * @return {string}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.getFetchUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.common.portal.gloo.solo.io.DataSource.prototype.setFetchUrl = function(value) {
  jspb.Message.setOneofField(this, 3, proto.common.portal.gloo.solo.io.DataSource.oneofGroups_[0], value);
};


proto.common.portal.gloo.solo.io.DataSource.prototype.clearFetchUrl = function() {
  jspb.Message.setOneofField(this, 3, proto.common.portal.gloo.solo.io.DataSource.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.hasFetchUrl = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ConfigMapData config_map = 4;
 * @return {?proto.common.portal.gloo.solo.io.DataSource.ConfigMapData}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.getConfigMap = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.DataSource.ConfigMapData} */ (
    jspb.Message.getWrapperField(this, proto.common.portal.gloo.solo.io.DataSource.ConfigMapData, 4));
};


/** @param {?proto.common.portal.gloo.solo.io.DataSource.ConfigMapData|undefined} value */
proto.common.portal.gloo.solo.io.DataSource.prototype.setConfigMap = function(value) {
  jspb.Message.setOneofWrapperField(this, 4, proto.common.portal.gloo.solo.io.DataSource.oneofGroups_[0], value);
};


proto.common.portal.gloo.solo.io.DataSource.prototype.clearConfigMap = function() {
  this.setConfigMap(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.common.portal.gloo.solo.io.DataSource.prototype.hasConfigMap = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.portal.gloo.solo.io.ObjectRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.portal.gloo.solo.io.ObjectRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.common.portal.gloo.solo.io.ObjectRef.displayName = 'proto.common.portal.gloo.solo.io.ObjectRef';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.portal.gloo.solo.io.ObjectRef.prototype.toObject = function(opt_includeInstance) {
  return proto.common.portal.gloo.solo.io.ObjectRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.portal.gloo.solo.io.ObjectRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.portal.gloo.solo.io.ObjectRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    namespace: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.common.portal.gloo.solo.io.ObjectRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.portal.gloo.solo.io.ObjectRef;
  return proto.common.portal.gloo.solo.io.ObjectRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.portal.gloo.solo.io.ObjectRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.common.portal.gloo.solo.io.ObjectRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.portal.gloo.solo.io.ObjectRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.portal.gloo.solo.io.ObjectRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.portal.gloo.solo.io.ObjectRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.portal.gloo.solo.io.ObjectRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.common.portal.gloo.solo.io.ObjectRef.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.common.portal.gloo.solo.io.ObjectRef.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string namespace = 2;
 * @return {string}
 */
proto.common.portal.gloo.solo.io.ObjectRef.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.common.portal.gloo.solo.io.ObjectRef.prototype.setNamespace = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.portal.gloo.solo.io.SecretRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.portal.gloo.solo.io.SecretRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.common.portal.gloo.solo.io.SecretRef.displayName = 'proto.common.portal.gloo.solo.io.SecretRef';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.portal.gloo.solo.io.SecretRef.prototype.toObject = function(opt_includeInstance) {
  return proto.common.portal.gloo.solo.io.SecretRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.portal.gloo.solo.io.SecretRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.portal.gloo.solo.io.SecretRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    namespace: jspb.Message.getFieldWithDefault(msg, 2, ""),
    key: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.portal.gloo.solo.io.SecretRef}
 */
proto.common.portal.gloo.solo.io.SecretRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.portal.gloo.solo.io.SecretRef;
  return proto.common.portal.gloo.solo.io.SecretRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.portal.gloo.solo.io.SecretRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.portal.gloo.solo.io.SecretRef}
 */
proto.common.portal.gloo.solo.io.SecretRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.portal.gloo.solo.io.SecretRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.portal.gloo.solo.io.SecretRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.portal.gloo.solo.io.SecretRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.portal.gloo.solo.io.SecretRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.common.portal.gloo.solo.io.SecretRef.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.common.portal.gloo.solo.io.SecretRef.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string namespace = 2;
 * @return {string}
 */
proto.common.portal.gloo.solo.io.SecretRef.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.common.portal.gloo.solo.io.SecretRef.prototype.setNamespace = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string key = 3;
 * @return {string}
 */
proto.common.portal.gloo.solo.io.SecretRef.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.common.portal.gloo.solo.io.SecretRef.prototype.setKey = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.portal.gloo.solo.io.LabelExpression = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.portal.gloo.solo.io.LabelExpression.repeatedFields_, null);
};
goog.inherits(proto.common.portal.gloo.solo.io.LabelExpression, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.common.portal.gloo.solo.io.LabelExpression.displayName = 'proto.common.portal.gloo.solo.io.LabelExpression';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.portal.gloo.solo.io.LabelExpression.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.portal.gloo.solo.io.LabelExpression.prototype.toObject = function(opt_includeInstance) {
  return proto.common.portal.gloo.solo.io.LabelExpression.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.portal.gloo.solo.io.LabelExpression} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.portal.gloo.solo.io.LabelExpression.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    operator: jspb.Message.getFieldWithDefault(msg, 2, 0),
    valuesList: jspb.Message.getRepeatedField(msg, 3)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.portal.gloo.solo.io.LabelExpression}
 */
proto.common.portal.gloo.solo.io.LabelExpression.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.portal.gloo.solo.io.LabelExpression;
  return proto.common.portal.gloo.solo.io.LabelExpression.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.portal.gloo.solo.io.LabelExpression} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.portal.gloo.solo.io.LabelExpression}
 */
proto.common.portal.gloo.solo.io.LabelExpression.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {!proto.common.portal.gloo.solo.io.LabelExpression.Operator} */ (reader.readEnum());
      msg.setOperator(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.portal.gloo.solo.io.LabelExpression.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.portal.gloo.solo.io.LabelExpression.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.portal.gloo.solo.io.LabelExpression} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.portal.gloo.solo.io.LabelExpression.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOperator();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.common.portal.gloo.solo.io.LabelExpression.Operator = {
  EQUALS: 0,
  DOUBLEEQUALS: 1,
  NOTEQUALS: 2,
  IN: 3,
  NOTIN: 4,
  EXISTS: 5,
  DOESNOTEXIST: 6,
  GREATERTHAN: 7,
  LESSTHAN: 8
};

/**
 * optional string key = 1;
 * @return {string}
 */
proto.common.portal.gloo.solo.io.LabelExpression.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.common.portal.gloo.solo.io.LabelExpression.prototype.setKey = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Operator operator = 2;
 * @return {!proto.common.portal.gloo.solo.io.LabelExpression.Operator}
 */
proto.common.portal.gloo.solo.io.LabelExpression.prototype.getOperator = function() {
  return /** @type {!proto.common.portal.gloo.solo.io.LabelExpression.Operator} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.common.portal.gloo.solo.io.LabelExpression.Operator} value */
proto.common.portal.gloo.solo.io.LabelExpression.prototype.setOperator = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated string values = 3;
 * @return {!Array<string>}
 */
proto.common.portal.gloo.solo.io.LabelExpression.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.common.portal.gloo.solo.io.LabelExpression.prototype.setValuesList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.common.portal.gloo.solo.io.LabelExpression.prototype.addValues = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


proto.common.portal.gloo.solo.io.LabelExpression.prototype.clearValuesList = function() {
  this.setValuesList([]);
};


/**
 * @enum {number}
 */
proto.common.portal.gloo.solo.io.State = {
  PENDING: 0,
  PROCESSING: 1,
  INVALID: 2,
  FAILED: 3,
  SUCCEEDED: 4
};

goog.object.extend(exports, proto.common.portal.gloo.solo.io);
